import { PodBase } from "../../PodBase";
import bsCustomFileInput from "bs-custom-file-input"

export default class Index extends PodBase {
    private url: string;

    constructor(url: string) {
        super();
        this.url = url;
        this.initialize();
    }

    initialize() {
        
        $("#btnOpenAddTicket").click(() => this.openAddTicket());
        $("#btnAddTicket").click(() => this.addTicket());
        $(".radioWho").click(() => this.radioWhoClicked());
        $(".ddlAgency").click(() => this.agencyChanged());

        bsCustomFileInput.init();

        ($("#frmSignup") as any).validate(
            {
                rules: {
                    txtFamilyName: { required: true },
                    txtFirstName: { required: true },
                    txtPostcode: { required: true }, // regex?
                    txtAddress: { required: true },
                    txtMobile: { require_from_group: [1, ".phone-group"] },
                    txtTelephone: { require_from_group: [1, ".phone-group"] },
                    txtEmail: { required: true },
                    txtCPCSNumber: { required: true },
                    txtDOB: { required: true, dateISO: true },
                    txtNI: { required: true },
                    chkAgree: { required: true },
                    chkConfirmUK: { required: true },
                    chkAgreeExisting: { required: true },
                    //divNoTickets: { required: "#divNoTickets:visible"},
                    ddlAgency: { required: "#ddlAgency:visible" }
                },
                highlight(element: any, errorClass: any, validClass: any) {
                    $(element).addClass("is-invalid");
                },
                unhighlight(element: any, errorClass: any, validClass: any) {
                    $(element).removeClass("is-invalid");
                },
                errorPlacement(error: any, element: any) { }
            });

        ($("#frmTicket") as any).validate(
            {
                rules: {
                    ddlTicket: { minlength: 1 },
                    txtTicketExpiry: { required: true, dateISO: true }
                },
                highlight(element: any, errorClass: any, validClass: any) {
                    $(element).addClass("is-invalid");
                },
                unhighlight(element: any, errorClass: any, validClass: any) {
                    $(element).removeClass("is-invalid");
                },
                errorPlacement(error: any, element: any) { }
            });

        $("#btnPhoto").change((event: any) => {
            this.readUrl(event.currentTarget);
        });

        //this.checkSubmit();
        $('#alreadyExists').hide();
        this.checkWho();
    };

    checkWho() {
        const selectedText = $("input[name='radioWho']:checked").val();
        if (!selectedText) {
            $(".signup-content").addClass("d-none");
        }
        else {
            $(".signup-content").removeClass("d-none");
        }
    }

    checkSubmit() {
        var signupForm = $("#frmSignup");
        var email = "" as string;
        const selectedText = $("input[name='radioWho']:checked").val();
        const isAgency = selectedText == "agency";
        if (!isAgency) {
            email = $("#txtEmail").val() as string;
        }

        ($ as any).ajax({
            type: "POST",
            data: { cpcs: $("#txtCPCSNumber").val(), email: email, mobile: $("#txtMobile").val() },

            dataType: "json",
            url: this.url,
            success: (result: any) => {
                // examine result
                $("#existingDetails").html("");
                if (result.cpcs != "" || result.email != "" || result.mobile != "") {
                    if (result.cpcs != "") {
                        $("#existingDetails").append("<span class=\"badge badge-danger mx-1\">CPCS Number</span>");
                        $("#warnCPCS").removeClass("collapse");
                    }
                    if (result.email != "") {
                        $("#existingDetails").append("<span class=\"badge badge-danger mx-1\">Email Address</span>");
                        $("#warnEmail").removeClass("collapse");
                    }
                    if (result.mobile != "") {
                        $("#existingDetails").append("<span class=\"badge badge-danger mx-1\">Mobile Number</span>");
                        $("#warnMobile").removeClass("collapse");
                    }
                    $("#alreadyExists").show();
                    window.scrollTo(0, 0);
                    // do not submit
                }
                else {
                    $("#alreadyExists").hide();
                }

                (signupForm as any).validate();

                if ((signupForm as any).valid()) {
                    // extra ticket check
                    if ($("#divNoTickets").is(":visible")) {
                        alert("You must enter at least one Ticket");
                    }
                    else {
                        signupForm.submit();
                    }
                }
                else {
                    alert("Cannot proceed - some required information is missing!");
                }

            },
            error: (msg: any) => {
                alert(JSON.stringify(msg));
            }
        });
    }

    agencyChanged() {
        const agency = $("#ddlAgency option:selected");
        const agencyId = agency.val();
        if (agencyId == "-1") {
            $("#txtAddress").val("");
            $("#txtPostcode").val("");
            $("#txtEmail").val("");
            $("#txtMobile").val("");
            $("#txtTelephone").val("");
        }
        else {
            $("#txtAddress").val(agency.data("add"));
            $("#txtPostcode").val(agency.data("pc"));
            $("#txtEmail").val(agency.data("em"));
            //$("#txtMobile").val(agency.data("mob"));
            $("#txtTelephone").val(agency.data("tel"));
        }

    };

    radioWhoClicked() {
        this.checkWho();
        const selectedText = $("input[name='radioWho']:checked").val();
        const isAgency = selectedText == "agency";

        $("#txtAddress").prop("readonly", isAgency);
        $("#txtPostcode").prop("readonly", isAgency);
        //$("#txtEmail").prop("readonly", isAgency); // keep email editable?
        $("#txtMobile").prop("readonly", isAgency);
        $("#txtTelephone").prop("readonly", isAgency);

        if (isAgency) {
            $("#divAgency").removeClass("d-none");
            $("#txtNI").val("");
            $("#txtMobile").val("");
        }
        else
            $("#divAgency").addClass("d-none");
    };
}
